import axios from 'axios';
import * as types from '../mutation-types';

const state = {
  inventoryTypes: [],
  rates: [],
  inventoryBlocks: [],
  ageQualifiers: [],
  initialized: false,
};

// getters
const getters = {
  inventoryTypes: s => s.inventoryTypes,
  rates: s => s.rates,
  inventoryBlocks: s => s.inventoryBlocks,
  ageQualifiers: s => s.ageQualifiers,
  initialized: s => s.initialized,
};

// actions
const actions = {
  async init({ commit }) {
    let resp = await axios.get('/api/inventory-types/');
    commit(types.MUTATE_INVENTORY_TYPES, resp.data);
    resp = await axios.get('/api/rate-plans/');
    commit(types.MUTATE_RATES, resp.data);
    resp = await axios.get('/api/inventory-blocks/');
    commit(types.MUTATE_INVENTORY_BLOCKS, resp.data);
    resp = await axios.get('/api/age-qualifiers/');
    commit(types.MUTATE_AGE_QUALIFIERS, resp.data);
    commit(types.MUTATE_INITIALIZED);
  },
};

// mutations
const mutations = {
  [types.MUTATE_INVENTORY_TYPES](s, inventoryTypes) {
    s.inventoryTypes = inventoryTypes;
  },
  [types.MUTATE_RATES](s, rates) {
    s.rates = rates;
  },
  [types.MUTATE_INVENTORY_BLOCKS](s, inventoryBlocks) {
    s.inventoryBlocks = inventoryBlocks;
  },
  [types.MUTATE_AGE_QUALIFIERS](s, ageQualifiers) {
    s.ageQualifiers = ageQualifiers;
  },
  [types.MUTATE_INITIALIZED](s) {
    s.initialized = true;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
